import { GalleryObject, GalleryObjectType } from "../../utils";
import styles from "./Content.module.scss";
import ImageMagnifier from "../ImageMagnifier/ImageMagnifier";
import { dispatchGalleryMonetateQEvent } from "../Analytics/dispatchGalleryMonetateQEvent";
import { useState } from "react";
import { useGalleryContext } from "../../GridGallery/GridGalleryContext";
import React from "react";
import { getTimeUpdateHandler } from "../Analytics/AdobeAnalytics";

interface ContentProps {
  content: GalleryObject;
  isSingleContent?: boolean;
  openModal: (event: any, imageSrc: string) => void; // eslint-disable-line @typescript-eslint/no-explicit-any
  position?: string;
  images: Array<GalleryObject>;
  isVideoLandscape?: boolean;
  zoomTooltipPortalContainer: HTMLDivElement;
  gridIndex: number;
}

export const Content = ({
  content,
  isSingleContent = false,
  openModal,
  position = "even",
  images,
  zoomTooltipPortalContainer,
  gridIndex,
}: ContentProps) => {
  const videoRef = React.useRef<HTMLVideoElement>(null);
  const videos = images.filter((go) => go.type === GalleryObjectType.VIDEO);
  const videoTimeline = React.useRef({
    started: false,
    reached50: false,
    videoCompleted: false,
  });

  const size = position === "even" ? (isSingleContent ? 1080 : 640) : 320;
  const isSingleVideo = videos.length === 1;
  const [isCustomPlayButtonVisible, setIsCustomPlayButtonVisible] =
    useState(true);

  const handleVideoClick = () => {
    if (videoRef.current) {
      videoRef.current.play();
    }
    setIsCustomPlayButtonVisible(false);
  };
  const { product, enableAnalytics, selectedVariant } = useGalleryContext() || {
    product: null,
    enableAnalytics: false,
    selectedVariant: null,
  };

  return content.type === GalleryObjectType.IMAGE ? (
    <div className={styles.imageContent}>
      <ImageMagnifier
        showIconOnly={false}
        src={content.imageUrl}
        alt={content.title}
        size={size}
        onClick={openModal}
        zoomTooltipPortalContainer={zoomTooltipPortalContainer}
        gridIndex={gridIndex}
        isCurrentIndex={true}
        zoomOnHover={true}
      />
    </div>
  ) : (
    isSingleVideo && (
      <div className={styles.videoContent}>
        <div
          onClick={() => {
            dispatchGalleryMonetateQEvent("VideoInteraction");
            handleVideoClick();
          }}
          data-testid={"grid:gallery:bottom:video:overlay"}
          className={
            isCustomPlayButtonVisible ? styles.videoContentOverlay : undefined
          }
        >
          <video
            ref={videoRef}
            data-testid="grid-gallery-video"
            preload="auto"
            poster={`${content.posterUrl}`}
            onPlay={() => {
              window.addEventListener("load", () => void 0);
              setIsCustomPlayButtonVisible(false);
            }}
            onTimeUpdate={() => {
              if (enableAnalytics) {
                getTimeUpdateHandler(
                  "pdp",
                  videoRef,
                  "0",
                  videoTimeline,
                  product,
                  selectedVariant,
                );
              }
            }}
            muted
            controls={isSingleVideo && !isCustomPlayButtonVisible}
          >
            <source src={content.videoUrl} type="video/mp4" />
          </video>
        </div>
      </div>
    )
  );
};
